import { assets } from './assets';
import React from 'react';
export const Icon: React.FC<{ name: string; alt: string; className?: string }> =
  ({ name, alt, className }) => {
    const icon = assets[name];
    return <img src={icon} alt={alt} className={className} />;
  };
